export default {
  PassengerSelector__BUTTON_GROUP_ARIA_NEXT: "Next",
  PassengerSelector__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
